import React from 'react';
import Container from '@mui/material/Container';
import TopGrid from '../components/top_grid';
import { DASHBOARD_URL } from '../const/config';

const Top = (props) => {
    const handleClick = (target) => {
        if (target === 'earthquake') {
            window.open('/earthquake_register', '_blank');
        } else if (target === 'dashboard') {
            window.open(DASHBOARD_URL, '_blank');
        }
    };

    return (
        <Container
            component="main"
            maxWidth="lg"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100dvh',
                paddingTop: { xs: '80px', sm: '100px' },
                paddingBottom: { xs: '40px' },
            }}
        >
            <TopGrid
                onEarthquakeClick={() => handleClick('earthquake')}
                onDashboardClick={() => handleClick('dashboard')}
            />
        </Container>
    );
};

export default Top;